export const AUTH_ENDPOINTS = {
  REGISTER: '/auth/register',
  GENERATE_ALL_OTP: '/auth/register/otp/generate-all',
  VERIFY_OTP: '/auth/register/otp/verify',
  LOGIN: '/auth/login',
  GENERATE_LOGIN_OTP: '/auth/login/otp/generate',
  VERIFY_LOGIN_OTP: '/auth/login/otp/verify',
};
